/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'navigation/left': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><path pid="0" _fill="none" d="M0 0h34v34H0z"/><path pid="1" d="M15.45 24h4.78l-6.76-7.38H27v-3.74H13.47l6.76-7.38h-4.78L7 14.72z" _fill="#e25046"/><path pid="2" _fill="#e25046" d="M23 13.62h4V28.5h-4z"/></g></g>'
  }
})
